import { render, staticRenderFns } from "./ModalMove.vue?vue&type=template&id=b5c92b00&scoped=true"
import script from "./ModalMove.vue?vue&type=script&lang=js"
export * from "./ModalMove.vue?vue&type=script&lang=js"
import style0 from "./ModalMove.vue?vue&type=style&index=0&id=b5c92b00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c92b00",
  null
  
)

export default component.exports